module.exports = __webpack_public_path__ + "media/images/mobile/home/search_w-4bcfccad809b9442d8ccea0890aa76c0.png";